/**
 * Whether this browser can keep a file across a reload (#4844), cached from
 * the store's probe. Unknown counts as no: a send holds until a probe has
 * answered yes, and a copy that failed to persist turns it back to no until
 * the next probe.
 */
export function createDurableStorageCheck(
  probe: (() => Promise<boolean>) | undefined
) {
  let durable: boolean | null = null;
  let probing: Promise<boolean> | null = null;
  const run = () => {
    probing ??= (probe?.() ?? Promise.resolve(false))
      .catch(() => false)
      .then((available) => {
        durable = available;
        probing = null;
        return available;
      });
    return probing;
  };
  return {
    probe: run,
    /** The cached answer; anything but a yes asks again in the background. */
    available() {
      if (durable !== true) void run();
      return durable === true;
    },
    unavailable() {
      durable = false;
    },
  };
}
